import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActiveBranch } from '../../core/services/session.service';
import { FulfillmentMode } from '../../core/models/order.model';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

const MODE_LABEL: Record<FulfillmentMode, string> = { delivery: 'Delivery to', pickup: 'Pickup from', dinein: 'Dine-in at' };
const MODE_ICON: Record<FulfillmentMode, string> = { delivery: 'solar:scooter-bold', pickup: 'solar:bag-3-bold', dinein: 'solar:tablet-bold' };

/** Location / fulfillment pill + search button used atop most pages. */
@Component({
  selector: 'app-fulfillment-bar',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="display:flex;align-items:center;gap:10px;padding:6px 14px 12px">
      <button (click)="pick.emit()"
        [style.background]="dark ? 'rgba(255,255,255,0.14)' : 'var(--fr-surface)'"
        [style.box-shadow]="dark ? 'none' : 'var(--fr-shadow-sm)'"
        [style.backdrop-filter]="dark ? 'blur(8px)' : 'none'"
        style="flex:1;min-width:0;display:flex;align-items:center;gap:9px;border:none;cursor:pointer;padding:7px 12px;border-radius:13px">
        <span [style.background]="dark ? 'rgba(255,255,255,0.16)' : 'var(--brand-tint)'"
          style="width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0">
          <app-icon [name]="modeIcon" [size]="18" [color]="dark ? '#fff' : 'var(--brand-deep)'"></app-icon>
        </span>
        <span style="min-width:0;text-align:start">
          <span [style.color]="sub" style="display:block;font-size:11px;font-weight:600">{{ modeLabel | t }}</span>
          <span [style.color]="fg" style="display:flex;align-items:center;gap:4px;font-weight:750;font-size:14px;letter-spacing:-0.01em">
            <span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ branch.area | t }}</span>
            <app-icon name="solar:alt-arrow-down-linear" [size]="15"></app-icon>
          </span>
        </span>
      </button>
      <!-- <button (click)="search.emit()"
        [style.background]="dark ? 'rgba(255,255,255,0.14)' : 'var(--fr-surface)'"
        [style.box-shadow]="dark ? 'none' : 'var(--fr-shadow-sm)'"
        [style.backdrop-filter]="dark ? 'blur(8px)' : 'none'"
        style="width:42px;height:42px;border-radius:12px;flex-shrink:0;cursor:pointer;border:none;display:flex;align-items:center;justify-content:center">
        <app-icon name="solar:magnifer-linear" [size]="20" [color]="fg"></app-icon>
      </button> -->
    </div>`,
})
export class FulfillmentBarComponent {
  @Input() fulfillment: FulfillmentMode = 'delivery';
  @Input() branch!: ActiveBranch;
  @Input() dark = false;
  @Output() pick = new EventEmitter<void>();
  @Output() search = new EventEmitter<void>();

  get modeLabel(): string { return MODE_LABEL[this.fulfillment]; }
  get modeIcon(): string { return MODE_ICON[this.fulfillment]; }
  get fg(): string { return this.dark ? '#fff' : 'var(--fr-text)'; }
  get sub(): string { return this.dark ? 'rgba(255,255,255,0.7)' : 'var(--fr-text-3)'; }
}
